import {MobileBox} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorIcons} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcons';
import {EditorContainer} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';

export const RevealEditorMobile = () => {
  const {onOverlayChange, overlayIcons, selectedOverlay} = useOverlay(false, true);

  return (
    <EditorContainer>
      <MobileBox title="Reveals">
        <EditorIcons
          className="editor-icons__reveal"
          icons={overlayIcons}
          onClick={onOverlayChange}
          highlight={false}
          selectedIcon={selectedOverlay}
          hideAnimatedIndicator
          height={58}
          width={50}
          outline
        />
      </MobileBox>
    </EditorContainer>
  );
};
